import { useQuery } from '@tanstack/react-query';
import { getCheckType } from '../apis/user.api';

const checkTypesArray = [
	{
		uuid: '03a799cc-28c2-4c92-8da2-e1e91c70c6d3',
		created_at: '2023-04-04T11:45:14.068314Z',
		updated_at: '2023-04-04T11:45:14.068590Z',
		name: 'Softcheck',
		value: 'request_softcheck',
		description:
			'Softcheck is a real-time search of over 200,000 databases from 200+ countries. It searches public media sources, sex offender registries, courts, fraud, sanctions and watchlists for adverse media for risk-relevant information such as: criminal history, fraud, affiliations with negative groups, global sanctions, public safety issues, public profile information and more.',
		is_active: true,
	},
	{
		uuid: 'c81de9ce-a0df-433a-bf48-aadff5811fe7',
		created_at: '2023-04-04T11:45:14.071146Z',
		updated_at: '2023-04-04T11:45:14.071380Z',
		name: 'Social Media Check',
		value: 'request_social_media_check',
		description:
			"Certn's Social Media Check is an analysis of candidates’ public posts across social media platforms, the web and news articles. Using machine learning, Certn retrieves these profiles, posts and images to determine if they fit into one or more pre-defined categories.",
		is_active: true,
	},
	{
		uuid: 'f4a6c021-1f25-4200-a434-9e1bf7c5fad3',
		created_at: '2023-04-04T11:45:14.073472Z',
		updated_at: '2023-04-04T11:45:14.073684Z',
		name: 'Identity Verification',
		value: 'request_identity_verification',
		description:
			"Certn uses credit data combined with questions from the applicant's credit file to verify the applicant's identity. Identity verification is required to complete a Canadian criminal record check.",
		is_active: true,
	},
	{
		uuid: '5ad9445f-d3a4-4751-a12e-a562959594b5',
		created_at: '2023-04-04T11:45:14.075716Z',
		updated_at: '2023-04-04T11:45:14.075908Z',
		name: 'Enhanced Canadian Criminal Record Check',
		value: 'request_enhanced_criminal_record_check',
		description:
			'All of the searches included in the Canadian Criminal Record Check plus a search of the Police Information Portal (PIP) looking for: Criminal convictions for which a pardon has not been granted, and conditional and absolute discharges which have not been removed from the CPIC system. Probation information, Wanted person information, Accused person information, Peace bonds, Judicial orders, Warrants, Absolute and Conditional Discharges (If relevant), Criminal charges that have been withdrawn, dismissed or Stayed of Proceedings, Any negative contact with Police.',
		is_active: true,
	},
	{
		uuid: '7317277b-00df-4020-affa-71ee40f664fa',
		created_at: '2023-04-04T11:45:14.077841Z',
		updated_at: '2023-04-04T11:45:14.078028Z',
		name: 'Canadian Criminal Record Check',
		value: 'request_criminal_record_check',
		description:
			'A Canadian police information check includes a search of the Canadian Police Information Centre (“CPIC”) database and locally held police information centres for: charges, warrants, peace bonds, prohibition orders, release conditions, probation orders, summary convictions, recent convictions not yet registered in the national repository.',
		is_active: true,
	},
	{
		uuid: '69d293fe-7f51-4517-b312-21a0a221e1fc',
		created_at: '2023-04-04T11:45:14.079920Z',
		updated_at: '2023-04-04T11:45:14.080127Z',
		name: 'US Base Criminal ',
		value: 'request_us_criminal_record_check_tier_1',
		description:
			'The check covers a search for the last seven years as reported by: Social Security Number Trace, Sex Offender Registry (National with Alias), National Criminal Database with Alias, Global Sanctions and Terrorist Watchlist Check with Alias. Reportable criminal records typically reflect felony and misdemeanor convictions and pending records for a seven year timeframe. Applicable access fees will be passed through.',
		is_active: true,
	},
	{
		uuid: '24d31ed4-b1d6-4ffd-ae4c-c02994124324',
		created_at: '2023-04-04T11:45:14.081987Z',
		updated_at: '2023-04-04T11:45:14.082176Z',
		name: 'US Single County Criminal',
		value: 'request_us_criminal_record_check_tier_2',
		description:
			'The check covers a search for the last seven years as reported by: Social Security Number Trace, Sex Offender Registry (National with Alias), National Criminal Database with Alias, Global Sanctions and Terrorist Watchlist Check with Alias, County level criminal record check for provided current address, Federal statewide criminal search for provided current address. Reportable criminal records typically reflect felony and misdemeanor convictions and pending records for a seven year timeframe. County searches are performed at the central courthouse in a specified county which houses the majority of felony and misdemeanor records for the county. Applicable access fees will be passed through.',
		is_active: true,
	},
	{
		uuid: '05e74ac2-5997-4093-824c-5172579af4bc',
		created_at: '2023-04-04T11:45:14.084076Z',
		updated_at: '2023-04-04T11:45:14.084274Z',
		name: 'US Unlimited County Criminal',
		value: 'request_us_criminal_record_check_tier_3',
		description:
			'The check covers a search for the last seven years as reported by: Social Security Number Trace, Sex Offender Registry (National with Alias), National Criminal Database with Alias, Global Sanctions and Terrorist Watchlist Check with Alias, County level criminal record check for the last seven years of the candidate’s address history, Federal statewide criminal search for the last seven years of the candidate’s address history. Reportable criminal records typically reflect felony and misdemeanor convictions and pending records for a seven year timeframe. County searches are performed at the central courthouse in a specified county which houses the majority of felony and misdemeanor records for the county. Applicable access fees will be passed through.',
		is_active: true,
	},
	{
		uuid: 'f22bddf5-538b-4fd1-a218-d5edc9b60e8e',
		created_at: '2023-04-04T11:45:14.086179Z',
		updated_at: '2023-04-04T11:45:14.086355Z',
		name: 'International Criminal Record Check',
		value: 'request_international_criminal_record_check',
		description:
			'Global criminal screenings are available in most countries. Prices, turnaround time, information availability, required forms, etc. can vary by country.',
		is_active: true,
	},
	{
		uuid: 'fac19ca1-503f-461f-8ab5-7c23885a31db',
		created_at: '2023-04-04T11:45:14.088218Z',
		updated_at: '2023-04-04T11:45:14.088393Z',
		name: 'Instant Education Verification ',
		value: 'request_education_verification',
		description:
			'Certn uses credible public sources to instantly verify the education of an individual with no manual intervention. This service will attempt to verify the disclosed education of an individual including their degree(s) received, course of study, and dates of attendance when available. This is NOT verified directly with the institution(s) listed and is not guaranteed to deliver a result.',
		is_active: true,
	},
	{
		uuid: '1c8cb089-1208-4360-a931-7a89d2e482ae',
		created_at: '2023-04-04T11:45:14.090243Z',
		updated_at: '2023-04-04T11:45:14.090414Z',
		name: 'Credential Verification ',
		value: 'request_credential_verification',
		description:
			"A credential verification validates a candidate's professional credential/license as entered by the candidate. Certn makes 3-5 sufficient attempts to obtain source data for verification and reports back accordingly.",
		is_active: true,
	},
	{
		uuid: '62d07bf8-4573-4bb9-ba73-8bab48918bb3',
		created_at: '2023-04-04T11:45:14.092348Z',
		updated_at: '2023-04-04T11:45:14.092536Z',
		name: 'Employment Verification',
		value: 'request_employment_verification',
		description:
			"An employment verification validates the details of disclosed employment history of an individual. Current employers are contacted only if given permission to do so. The components verified could include position held and dates of employment and will depend on availability of data within an entity's records. Income verification is also obtained for non-employment purposes only. Certn makes 3-5 sufficient attempts to obtain source data for verification and reports back accordingly. Additional fees can apply when an employer utilizes an outsourced entity to provide data. More information.",
		is_active: true,
	},
];

export type CheckTypeArray = typeof checkTypesArray;

export function useCheckTypes() {
	return useQuery({
		queryKey: ['check-types'],
		queryFn: async () => {
			const { results } = await getCheckType();
			return results as CheckTypeArray;
		},
		staleTime: 1000 * 60,
	});
}
